import React from "react";
import "./styles.scss";
import "@ta-interaktiv/semantic-ui/semantic/dist/components/placeholder.css";
import "@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css";
import Cover from "../cover";

class Candidates extends React.Component {
  render() {
    return (
      <>
        <div className="ui mobile hidden">
          <Cover
            title="Des questions et des candidats"
            subtitle="Sept femmes et neuf hommes convoitent le Conseil administratif. Nous leur avons demandé de prendre position sur huit sujets clés en Ville de Genève."
          />
        </div>

        <div className="ui mobile only">
          <div
            style={{ background: "#2C3891", height: "54px", width: "100%" }}
          />
          <header className="ui vertical very relaxed white segment">
            <div className="ui text container">
              <h1 className="ui image header" style={{ marginTop: "2em" }}>
                <div className="content">
                  Des questions et des candidats{" "}
                  <div className="sub header">
                    Sept femmes et neuf hommes convoitent le Conseil
                    administratif. Nous leur avons demandé de prendre position
                    sur huit sujets clés en Ville de Genève.
                  </div>
                </div>
              </h1>
            </div>
          </header>

          <div className="video-header">
            <div className="embed-container">
              <video autoPlay loop playsInline muted>
                <source
                  src="https://interactif.tdg.ch/2020/questions-candidats-conseil-administratif-geneve/videos/intro.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
        </div>

        <div className="ui text container" style={{ marginTop: "4em" }}>
          <h3 className="ui header" id="candidats">
            Les candidats
          </h3>
        </div>

        <div className="ui vertical segment container">
          {this.props.candidates.length === 0 && (
            <div className="ui placeholder">
              <div className="paragraph">
                <div className="line" />
                <div className="line" />
                <div className="line" />
                <div className="line" />
                <div className="line" />
              </div>
              <div className="paragraph">
                <div className="line" />
                <div className="line" />
                <div className="line" />
              </div>
            </div>
          )}
          <div className="ui grid list candidates-list-alternative">
            {this.props.candidates.map((row, i) => (
              <div
                key={"candidate-" + i}
                className="height wide mobile five wide tablet five wide computer column candidate-cell item center aligned"
                onClick={() => {
                  this.props.history.push("/candidats/" + row.id);
                }}
              >
                <div className="ui raised segment candidate-cell-content">
                  {/* <div className='share'><i className='ui chain icon' /></div> */}
                  <div className="candidate-cell-header ui">
                    <div>
                      <div className="candidate-picture">
                        <div
                          className="picture"
                          style={{
                            backgroundImage:
                              "url(" +
                              require("../../images/candidates/300x300/" +
                                row.id +
                                ".png") +
                              ")"
                          }}
                        />
                      </div>
                    </div>
                    <div>
                      <div className="header">
                        <div>
                          {row["prénom"]} {row.nom}
                        </div>
                      </div>
                      <div style={{ marginTop: ".35em" }} className="party">
                        {row.liste}
                      </div>
                    </div>
                  </div>
                  <div className="ui mini-menu">
                    <span>Les réponses</span>{" "}
                    <i className="ui icon chevron right small" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="ui vertical blue segment">
          <div className="ui text container">
            <h3 id="questions" className="ui header">
              Les questions
            </h3>
            <div className="ui vertical segment">
              <div className="ui list questions">
                {this.props.questions.map((question, i) => (
                  <div
                    key={"question-menu-" + i}
                    className="item"
                    onClick={() => {
                      this.props.history.push("/questions/" + (i + 1));
                    }}
                  >
                    <div className="nav-link">{question.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Candidates;
